import { useState } from "react";

import config from "appConfig";
import useLocale from "@/hooks/useLocale";
import { useMessage } from "@/hooks/useMessage";
import { telemetry } from "@/utilities/telemetry";

type EntryShareMessagePayload = {
  name: string;
  hideStake: boolean;
  referenceId: string;
};

type MessageApiResponse = {
  shareId: string;
};

export function useShareUrl(referenceId: string) {
  const [requestShareUrl] =
    useMessage<MessageApiResponse>("create-entry-share");

  const locale = useLocale();

  const [shareUrl, setShareUrl] = useState("");

  const getShareUrl = async ({ name, hideStake }: EntryShareMessagePayload) => {
    const payload = {
      referenceId,
      name,
      hideStake,
    };
    const response = await requestShareUrl(payload);
    const url = `${config.DOMAIN}/${locale}/share/${response.shareId}`;

    telemetry.sharedEntry({ url, date: new Date().toISOString(), ...payload });
    setShareUrl(url);

    return url;
  };

  return [shareUrl, getShareUrl, setShareUrl] as const;
}
